import { fontSizes } from './fontSizes';

export const textStyles = {
  h1: {
    fontSize: fontSizes.xl,
  },
};
